import React, { useEffect } from 'react';
import _ from 'lodash';
import {
  CHANNEL_GROUP_ICONS_MAP,
  CHANNEL_GROUPS,
  CHANNEL_GROUP_DISPLAY_NAMES,
  CHANNEL_GROUPS_DESCRIPTION,
  PROJECT_ES_FIELDS,
  INTERNAL_STATUS, CHANNEL_GROUP_ENABLED,
} from 'omega-rtc/constants/ucd';
import { connect } from 'react-redux';
import { Select, Form, Input } from 'grab-ui';
import { suggestUCDProjects } from '../../../actions/ucd';
import 'omega-rtc/components/form/ucd/AddCampaignChannelForm.scss';

// the commented part are for the project info display, which is currently hidden
// import { getCountryNameFromCountryID } from 'omega-rtc/utils/ucd-utils';
// import UCDStatusLabel from './common/UCDStatusLabel';
// import moment from 'moment';

type Props = {
  onChannelGroupChange: Function,
  value: string,
  projectSuggestions: [],
  dispatch: any,
  form: any,
  project: Object,
};

const AddCampaignChannelForm = (props: Props) => {
  const { getFieldDecorator } = props.form;
  const onChannelGroupChange = (newChannelGroup) => {
    if (props.form.getFieldValue('channelGroup') !== newChannelGroup) {
      props.form.setFieldsValue({ channelGroup: newChannelGroup });
      if (props.form.getFieldValue('channelType')) {
        props.form.setFieldsValue({ channelType: [] });
      }
      props.onChannelGroupChange(newChannelGroup);
    }
  };

  const getBaseRequestObject = () => {
    return {
      sort: {
        field: PROJECT_ES_FIELDS.updatedAt,
        asc: false,
      },
      page: 1,
      pageSize: 10,
      filters: [ // filters for fetching only draft and active projects
        {
          lhs: PROJECT_ES_FIELDS.status,
          operator: 'in',
          rhs: [INTERNAL_STATUS.draft, INTERNAL_STATUS.active],
        },
      ],
    };
  };

  const onProjectChange = _.debounce((newProject) => {
    const request = getBaseRequestObject();
    if (newProject) {
      request.filters.push({
        lhs: PROJECT_ES_FIELDS.name,
        operator: 'match',
        rhs: newProject,
      });
    }
    props.dispatch(suggestUCDProjects(request));
  }, 500);

  useEffect(() => {
    if (props.project) {
      props.form.setFieldsValue({ project: props.project });
    }
    props.dispatch(suggestUCDProjects(getBaseRequestObject()));
  }, []);

  return (
    <div>
      <div>
        {!props.project && <div style={{ marginTop: '40px', marginBottom: '11px', fontWeight: 'bold' }}><span
          style={{ color: 'red', marginRight: '2px' }}
        >*</span>Project</div>}
        <Form.Item style={{ display: 'none' }}>
          {getFieldDecorator('project', {})(<Input />)}
        </Form.Item>
        {
          !props.project &&
          <Form.Item style={{ marginBottom: '10px' }}>
            {getFieldDecorator('projectID', {
              rules: [
                {
                  required: true,
                },
              ],
            })(
              <Select
                showSearch
                filterOption={false}
                onChange={(projectID) => {
                  props.form.setFieldsValue({ project: _.find(props.projectSuggestions, project => project.projectID === projectID) });
                }}
                onSearch={onProjectChange}
                placeholder="Select a project"
                style={{
                  width: '100%',
                }}
                notFoundContent={<div style={{ display: 'flex', justifyContent: 'center' }}>No Project Found</div>}
              >
                {props.projectSuggestions.map((projectSuggestion) => {
                  return (<Select.Option value={projectSuggestion.projectID} key={projectSuggestion.projectID}>
                    {projectSuggestion.project.name}
                  </Select.Option>);
                })}
              </Select>
            )}
          </Form.Item>
        }
      </div>
      {/* { */}
      {/*  props.project && */}
      {/*  <div style={{ marginTop: '40px', border: '1px solid #E8E8E8', borderRadius: '8px', padding: '18px 20px' }}> */}
      {/*    <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
      {/*      <div style={{ width: '100%' }}> */}
      {/*        <div style={{ fontSize: '17px', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '75%' }}>{_.get(props.project, 'project.name', '')}</div> */}
      {/*        <div style={{ fontSize: '14px', color: '#707070' }}> */}
      {/*          <span style={{ marginRight: '3px' }}>{getCountryNameFromCountryID(_.get(props.project, 'project.countryID'), props.countries)}</span> */}
      {/*          <span style={{ marginRight: '3px' }}>.</span> */}
      {/*          <span>{_.get(props.project, 'campaignCount') || 0} Campaigns</span> */}
      {/*        </div> */}
      {/*      </div> */}
      {/*      <div className="project-actions-column"> */}
      {/*        <UCDStatusLabel status={_.get(props.project, 'status')} start={_.get(props.project, 'project.start')} end={_.get(props.project, 'project.end')} labelSize={'medium'} /> */}
      {/*      </div> */}
      {/*    </div> */}
      {/*    <div style={{ marginTop: '15px', color: '#707070', fontSize: '14px' }}> */}
      {/*      <div style={{ display: 'flex' }}><div style={{ width: '80px' }}>Start Date : </div>{moment(_.get(props.project, 'project.start')).format('MM/DD/YYYY')}</div> */}
      {/*      <div style={{ display: 'flex', whiteSpace: 'pre' }}><div style={{ width: '80px' }}>End Date   :</div> {moment(_.get(props.project, 'project.end')).format('MM/DD/YYYY')}</div> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* } */}
      <Form.Item>
        {getFieldDecorator('channelGroup', {
          rules: [
            {
              required: true,
            },
          ],
        })(
          <div className={'card-page-container'}>
            {Object.keys(CHANNEL_GROUPS).map((channelGroup) => {
              let cardClass = 'channelGroupCard';
              if (!_.get(CHANNEL_GROUP_ENABLED, channelGroup, false)) {
                cardClass += ' disabled';
              }
              if (props.value === channelGroup) {
                cardClass += ' active';
              }

              return (
                <div className={cardClass} key={channelGroup} onClick={() => { onChannelGroupChange(channelGroup); }}>
                  <div>
                    <img src={_.get(CHANNEL_GROUP_ICONS_MAP, channelGroup)} alt={channelGroup} />
                  </div>
                  <div style={{ marginLeft: '13px' }}>
                    <div className={'title'}>{_.get(CHANNEL_GROUP_DISPLAY_NAMES, channelGroup)}</div>
                    <div className={'body'}>{_.get(CHANNEL_GROUPS_DESCRIPTION, channelGroup)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Form.Item>
    </div>
  );
};

export function mapStateToProps(state: StoreState) {
  return {
    projectSuggestions: state.ucd.projectSuggestions,
    countries: state.countries.entities,
  };
}

export default connect(mapStateToProps)(AddCampaignChannelForm);
